module.exports = __webpack_public_path__ + "img/select-3-2.166a0b7e.png";